import type { ContactPreferenceChannel } from '@shared/config';

/**
 * Maps channel preference labels to their corresponding API keys
 */
function mapChannelsToApiKeys(channelLabels: string[]): ContactPreferenceChannel[] {
  return channelLabels
    .map((label): ContactPreferenceChannel | '' => {
      const normalised = label.toLowerCase();
      if (normalised.includes('email')) return 'email';
      if (normalised.includes('sms')) return 'sms';
      if (normalised.includes('phone')) return 'phone';
      if (normalised.includes('trusted')) return 'trustedPartners';
      if (normalised.includes('post')) return 'post';
      return '';
    })
    .filter((channel): channel is ContactPreferenceChannel => channel !== '');
}

/**
 * Maps channel API keys to their corresponding display labels
 */
function mapApiKeysToChannelLabels(apiKeys: string[], t: (key: string) => string): string[] {
  return apiKeys.map(apiKey => {
    switch (apiKey.toLowerCase()) {
      case 'email':
        return t('contact_preferences.channels_labels.email');
      case 'sms':
        return t('contact_preferences.channels_labels.sms');
      case 'phone':
        return t('contact_preferences.channels_labels.phone_call');
      case 'post':
        return t('contact_preferences.channels_labels.post');
      case 'trustedpartners':
        return t('contact_preferences.channels_labels.targeted_advertising');
      default:
        return apiKey;
    }
  });
}

export { mapApiKeysToChannelLabels, mapChannelsToApiKeys };
